import { useState } from "react";
import SignupPage from '../../../../components/marketplace/SignupPage'
import OtpVerification from "../../../../components/marketplace/OtpVerification";


const AddDeanUserManually = () => {
    const [isCreate,setIsCreate]=useState(false)
    const [signupSuccess,setSignupSucess]=useState(false)
    const [emails,setEmails]=useState("")

  return (
   <>
 

  {signupSuccess ? <OtpVerification email={emails}/> :isCreate ?  <SignupPage setSignupSucess={setSignupSucess} setEmails={setEmails} />  :  <div className="p-6 bg-white rounded-2xl shadow-sm border border-gray-100">
    {/* Header */}
    <div className="flex items-center gap-3 mb-6">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      </div>
      <h1 className="text-xl font-semibold text-gray-900">Creating a Dean User Manually</h1>
    </div>

    <p className="text-sm text-gray-600 mb-6">
      To create a dean user manually, you need to follow these two steps:
    </p>

    {/* Steps */}
    <div className="space-y-3 mb-8">
      <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
        <div className="w-6 h-6 bg-[#e8f0f7] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
          <span className="text-xs font-semibold text-[#0f6abf]">1</span>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">Create an account:</span>
          <span className="text-sm text-gray-600 ml-1">Set up a user account with the dean's <span className="font-medium">email</span> and a secure <span className="font-medium">password</span>.</span>
        </div>
      </div>

      <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-xl">
        <div className="w-6 h-6 bg-[#e8f0f7] rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
          <span className="text-xs font-semibold text-[#0f6abf]">2</span>
        </div>
        <div>
          <span className="text-sm font-medium text-gray-900">Verify the account:</span>
          <span className="text-sm text-gray-600 ml-1">Send an <span className="font-medium">OTP</span> to the dean's email and verify their account.</span>
        </div>
      </div>

    
    </div>

    {/* Action */}
    <div className="border-t border-gray-200 pt-6">
      <p className="text-sm font-medium text-gray-700 mb-4">Do you want to create a dean manually?</p>
      <button
        onClick={() => setIsCreate(!isCreate)}
        className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
        </svg>
        Create Dean Manually
      </button>
    </div>
  </div>}
</>
  );
};

export default AddDeanUserManually;
